import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { useInvestmentAmount as useInvestmentAmountBySector } from '../../hooks/useInvestmentAmountBySector';
import { CHART_COMPONENTS } from '../../../../types';
import { PieChart } from '../../../../components/Charts/Piechart/PieChart';
import { sectorsColourState } from '../../../../services/state/SectorStateJ';
import { IMetricsDataModel } from '../../../../data-models/metrics.data-model';
import { IPortfolioChartProps } from './ChartComponent';
import { allChartItems } from './ChartsSection';

export const InvestmentAmountBySectorChart: FC<IPortfolioChartProps<IMetricsDataModel>> = (props) => {
  const { data, total } = useInvestmentAmountBySector(props.filteredMetrics);
  const sectorColours = useAtomValue(sectorsColourState);

  return (
    <PieChart
      chartColors={sectorColours}
      data={data}
      id={CHART_COMPONENTS.INVESTMENT_AMOUNT_BY_SECTOR}
      title={allChartItems.get(CHART_COMPONENTS.INVESTMENT_AMOUNT_BY_SECTOR)?.value ?? 'Investment by Sector'}
      total={total}
      isFullScreen={props.isFullScreen}
      onOpenFullScreen={props.onOpenFullScreen}
    />
  );
};
